import OadpEntityButtonUpdate from './oadp-entity-button-update';
export default OadpEntityButtonUpdate;
